// extracted by mini-css-extract-plugin
export var layoutContainer = "_3z-0";
export var layoutContainerOpen = "_3z-5";
export var layoutContainerResizing = "_3z-1";
export var mainContent = "_3z-2";
export var resizeDivider = "_3z-3";
export var slidePanel = "_3z-4";